import { render, staticRenderFns } from "./order_address_edit.vue?vue&type=template&id=46fc31f4&scoped=true"
import script from "./order_address_edit.vue?vue&type=script&lang=js"
export * from "./order_address_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc31f4",
  null
  
)

export default component.exports